package games.polyclub.website.frontend.store.components

import adminlte.layout.Layout
import adminlte.layout.LayoutConfig
import adminlte.layout.LayoutOptions
import games.polyclub.frontend.lib.react.simplified.SFC
import games.polyclub.frontend.lib.react.simplified.tags.*
import games.polyclub.website.frontend.store.hooks.useUserPreferences
import games.polyclub.website.frontend.store.layout.Footer
import games.polyclub.website.frontend.store.layout.PreloadAnimation
import games.polyclub.website.frontend.store.layout.Sidebar
import games.polyclub.website.frontend.store.layout.TopBar
import jquery.jQuery
import js.core.jso
import react.Props
import react.router.Outlet
import react.useEffect
import web.dom.document

val Layout = SFC<Props> { _ ->
    val userPreferencesCtx = useUserPreferences()
    useEffect {
        document.body.style.height = "auto"
        val body = jQuery("body")
        body.Layout(jso<LayoutOptions>{
            scrollbarAutoHide = true
            panelAutoHeight = true
        }).Layout(LayoutConfig.INIT).Layout(LayoutConfig.FIX_LAYOUT_HEIGHT)
        jQuery("#wrapper").addClass("wrapper")
        jQuery("#wrapper, body, html").removeClass("forced_height_100 img_in_middle")
        if (userPreferencesCtx.preferences.darkMode) {
            body.addClass("dark-mode")
        } else {
            body.removeClass("dark-mode")
        }
        cleanup {
            body.removeClass("hold-transition layout-fixed dark-mode")
            jQuery("#wrapper").removeClass("wrapper")
        }
    }
    PreloadAnimation()
    TopBar()
    Sidebar()
    div("content-wrapper") {
        Outlet()
    }
    Footer()
}
